module.exports = __webpack_public_path__ + "static/Logo_UTFSM-6741f33ff94c55bb5c9d57ee11cc2914.png";